import { render, staticRenderFns } from "./ReportInvoices.vue?vue&type=template&id=22d70e0b"
import script from "./ReportInvoices.vue?vue&type=script&lang=js"
export * from "./ReportInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d70e0b')) {
      api.createRecord('22d70e0b', component.options)
    } else {
      api.reload('22d70e0b', component.options)
    }
    module.hot.accept("./ReportInvoices.vue?vue&type=template&id=22d70e0b", function () {
      api.rerender('22d70e0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/ReportInvoices.vue"
export default component.exports